@if (basdata && searchFilter) {
  <rask-arbetsorder-search-filter [title]="texts.filters.grot" (toggleVisibility)="toggleShow()" [visible]="isVisible" [hasValues]="isDirty()" aid="filterGrot">
    <div class="grotskotning">
      <rask-radiobutton-group
        [label]="texts.grotskotning"
        [infoText]="texts.grotskotninginfo"
        aid="filterGrotGrotskotning"
        (change)="setGrotskotningValue($event)"
        [buttons]="[{ key: 0, value: texts.grotskotningNej }, { key: 1, value: texts.grotskotningJa }, { key: 2, value: texts.grotskotningJaMedRundvirke }]"
        [ngModel]="getGrotskotningValue()">
      </rask-radiobutton-group>
      <rask-multi-selector
        class="grot-relaterad-rv-maskinlag"
        label="Maskinlag relaterad rv"
        aid="filterGrotRelateratRundvirkeMaskinlag"
        [items]="allaMaskinlag"
        bindLabel="namn"
        [selected]="searchFilter.grot.grotRelateratRundvirkeMaskinlag"
        (change)="onChangeMaskinlag($event)"
        [searchFn]="searchMaskinlagFn"
        [viewFormatter]="tradslagViewFormatterFn"
        >
      </rask-multi-selector>
    </div>
    <div class="grotskotning-panel">
      <rask-header size="4" class="component-header">{{texts.grotskordad}}</rask-header>
      <div class="grotskotning-panel-items">
        <rask-radiobutton-group aid="filterGrotGrotskordad" (change)="setGrotskordadValue($event)" [buttons]="[{ key: -1, value: texts.grotskordAlla }, { key: 1, value: texts.grotskordJa }, { key: 0, value: texts.grotskordNej }]" [ngModel]="getGrotskordadValue()"></rask-radiobutton-group>
      </div>
    </div>
    <div class="grotskordning-panel">
      <rask-header size="4" class="component-header">{{texts.grotskorddatum}}</rask-header>
      <rask-datepicker-interval
        [appendToBody]="false"
        [disabled]="areDatePickersDisabled()"
        [labelStartDate]="texts.grotfrom"
        [labelEndDate]="texts.grottom"
        startDate="{{getStartDate()}}"
        (startDate)="setStartDate($event)"
        endDate="{{getEndDate()}}"
        (endDate)="setEndDate($event)"
        [onlyMonths]="false"
        aid="filterGrotGrotskorddatum">
      </rask-datepicker-interval>
    </div>
  </rask-arbetsorder-search-filter>
}
